import { api } from './client';
import type { IdentityResponse, IdentityUpsertRequest } from '@/types/api';

export const identitiesApi = {
  async list(): Promise<IdentityResponse[]> {
    const res = await api.get<IdentityResponse[]>('/identities');
    return res.data;
  },

  async get(id: string): Promise<IdentityResponse> {
    const res = await api.get<IdentityResponse>(`/identities/${id}`);
    return res.data;
  },

  async create(body: IdentityUpsertRequest): Promise<IdentityResponse> {
    const res = await api.post<IdentityResponse>('/identities', body);
    return res.data;
  },

  async update(id: string, body: Partial<IdentityUpsertRequest>): Promise<IdentityResponse> {
    const res = await api.patch<IdentityResponse>(`/identities/${id}`, body);
    return res.data;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/identities/${id}`);
  },
};
